module.exports = __webpack_public_path__ + "img/retro_sec7.f9045097.jpg";